import { Card, CardActions, CardContent, CardHeader, Container, IconButton, Paper, Stack, Tooltip, Typography } from "@mui/material"
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import { Gauge, gaugeClasses } from "@mui/x-charts";
import PoolIcon from '@mui/icons-material/Pool';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const MuiDashboardLeave = () => {
    return (

        <Card sx={{ height: 300 }}>
            <CardHeader
                subheader="Yıllık İzin"
                avatar={<PoolIcon />}
                action=
                {
                    <Stack direction="row">
                        <Tooltip title="İzin iste">
                            <IconButton>
                                <AddIcon color="warning" />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="İzin detayları">
                            <IconButton>
                                <MoreHorizIcon/>
                            </IconButton>
                        </Tooltip>

                    </Stack>

                }


            />

            <CardContent>

                <Typography variant="h5" component="div">
                    Kalan: 7 gün
                </Typography>
                <Typography fontSize={12} sx={{ mb: 1.5 }} color="text.secondary">
                    Geçmiş izin haklarınız için detay sayfasına gidiniz.
                </Typography>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 1, md: 3 }}>
                    <Gauge width={150} height={150} value={14} valueMax={21}
                        startAngle={-110}
                        endAngle={110}
                        text={
                            ({ value, valueMax }) => `${value} / ${valueMax}`
                        }
                    />
                </Stack>

            </CardContent>

        </Card>
    )
}

export default MuiDashboardLeave